import type { SurveyFilters } from "../../types/defaultTypes";
import { apiClient } from "../clientApi";
import type { AxiosResponse } from "axios";

type SurveyOption = {
  id: string;
  order: number;
  answer: string;
};

type SurveySettings = {
  maxChars: number;
  minChars: number;
};

type SurveyQuestion = {
  id: string;
  text: string;
  type: "single-choice" | "multiple-choice" | string;
  order: number;
  options: SurveyOption[];
  settings: SurveySettings;
  correctAnswers: string[];
};

export type Survey = {
  id: number;
  org_id: number;
  course_name: string;
  title: string | null;
  description: string | null;
  status: string | null;
  auto_send: boolean;
  include_previous: boolean;
  subject: string | null;
  email_subheader: string | null;
  email_header: string | null;
  email_body: string | null;
  survey_json: SurveyQuestion[];
  send_delay: number | null;
  created_by: number | null;
  created_at: string; // ISO timestamp
  updated_at: string; // ISO timestamp
};

export const getSurveyDetails = async (id: number | string, courseName: string) => {
  const { data } = await apiClient.get<Survey, AxiosResponse<Survey>>(
    `/surveys/survey/${id}/${courseName?.toLowerCase()}`
  );

  return data as Survey;
};
